export const UPPERCASE = 'uppercase';
export const LOWERCASE = 'lowercase';
export const CAPITALIZE = 'capitalize';
